import { formatBalance, formatIsoDay, formatMoney, formatTRY } from "@/lib/format";
import { StatusBadge } from "@/lib/orders";

const Cell = ({ label, value, tone = "text-slate-900", testid }) => (
  <div className="px-3 py-2 border-r border-b border-slate-100" data-testid={testid}>
    <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">{label}</div>
    <div className={`font-mono text-[13px] font-semibold ${tone}`}>{value}</div>
  </div>
);

export default function CustomerPanel({ s, onAddProduct }) {
  const sm = s.summary;
  return (
    <div className="panel overflow-hidden fade-up" data-testid="qs-customer-panel">
      <div className="px-3 py-2 border-b border-slate-200 flex items-center justify-between">
        <div className="min-w-0"><div className="font-semibold text-slate-900 truncate" data-testid="qs-customer-title">{s.title}</div>
          <div className="text-[11px] text-slate-500">{s.code} · {s.phone} · Vade {s.vade_days} gün · {s.sales_rep_name}</div></div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3">
        <Cell label="Bakiye" value={formatBalance(s.balance)} testid="qs-balance" />
        <Cell label="Risk Limiti" value={formatTRY(s.risk_limit)} testid="qs-risk-limit" />
        <Cell label="Kullanılan Risk" value={formatTRY(sm.risk_used)} testid="qs-used-risk" />
        <Cell label="Kullanılabilir Limit" value={formatTRY(sm.available_risk)} tone={sm.available_risk < 0 ? "text-rose-600" : "text-emerald-700"} testid="qs-available-risk" />
        <Cell label="Vadesi Geçmiş" value={formatTRY(sm.overdue_debt)} tone={sm.overdue_debt > 0 ? "text-rose-600" : "text-slate-900"} testid="qs-overdue" />
        <Cell label="Son Sipariş" value={s.last_order ? `${formatIsoDay(s.last_order.order_date)} · ${formatTRY(s.last_order.grand_total_try)}` : "—"} testid="qs-last-order" />
      </div>
      {s.last_products?.length > 0 && (
        <div className="max-h-40 overflow-y-auto" data-testid="qs-last-products">
          <div className="px-3 pt-2 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Son aldığı ürünler · son fiyat {s.last_order && <StatusBadge status={s.last_order.status} />}</div>
          {s.last_products.map((p) => (
            <button key={p.product_id} type="button" onClick={() => onAddProduct(p.product_id)} data-testid={`qs-last-product-${p.sku}`}
              className="w-full flex justify-between gap-2 px-3 py-1 text-[12px] hover:bg-blue-50 text-left">
              <span className="truncate"><span className="font-mono text-slate-500">{p.sku}</span> {p.name}</span>
              <span className="font-mono whitespace-nowrap text-slate-700">{formatMoney(p.net_unit_price, p.currency)} · {formatIsoDay(p.date)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
